/* tc-product: swatches, gallery sets, add to cart (reference store or native form), express plate, mobile counter, sticky bar. */
(function () {
  'use strict';
  var TC = window.TC = window.TC || {};
  function parseCents(text) {
    var m = String(text || '').replace(/[^0-9.,]/g, '');
    if (!m) return 0;
    var clean = m;
    if (/[.,]\d{3}$/.test(clean) && !/[.,]\d{2}$/.test(clean)) clean = clean.replace(/[.,]/g, ''); else clean = clean.replace(/,/g, '');
    return Math.round((parseFloat(clean) || 0) * 100);
  }
  function noDecimals(text) { return String(text).replace(/([.,])00(?!\d)/, ''); }
  TC.openMinicart = TC.openMinicart || function () {
    var cfg = window.TC_CONFIG || {};
    if (cfg.cartType === 'page' && cfg.cartUrl) { window.location.href = cfg.cartUrl; return true; }
    var m = document.querySelector('[data-tc-minicart]');
    if (m && TC.overlay) { TC.overlay.open(m); return true; }
    return false;
  };

  TC.init('[data-tc-product]', function (root) {
    var mode = root.dataset.tcMode;
    var sectionEl = root.closest('.shopify-section') || root;
    var state = { set: root.dataset.tcActiveSet, value: null, priceText: root.dataset.tcPriceText, variant: null, variants: [] };
    var selected = root.querySelector('[data-tc-swatch][aria-pressed="true"]');
    if (selected) state.value = selected.dataset.tcValue;
    var variantsEl = root.querySelector('[data-tc-variants]');
    if (variantsEl) {
      try { state.variants = JSON.parse(variantsEl.textContent) || []; } catch (e) { state.variants = []; }
      var idEl = root.querySelector('[data-tc-variant-id]');
      if (idEl) state.variant = state.variants.filter(function (v) { return String(v.id) === String(idEl.value); })[0] || null;
    }
    var carousels = [];
    if (root.querySelector('[data-tc-product-video]')) {
      root.addEventListener('click', function (event) {
        var button = event.target.closest('[data-tc-video-play]');
        if (!button || !root.contains(button)) return;
        var tile = button.closest('[data-tc-product-video]');
        var template = tile.querySelector('[data-tc-video-template]');
        if (!template || tile.querySelector('.tc-video-player')) return;
        event.preventDefault();
        tile.appendChild(template.content.cloneNode(true));
        button.hidden = true;
        var player = tile.querySelector('.tc-video-player');
        player.focus();
        if (player.tagName === 'VIDEO') player.play().catch(function () {});
      });
    }

    /* size selector (table aside): reference rows from the block, Shopify rows from the product option named by the block */
    var sizeBlock = root.querySelector('[data-tc-size]');
    var sizePos = sizeBlock ? parseInt(sizeBlock.dataset.tcSizePosition || '0', 10) : 0;
    state.size = null;
    if (sizeBlock) { var pickedSize = sizeBlock.querySelector('[data-tc-size-pick].selected'); if (pickedSize) state.size = pickedSize.dataset.tcSizePick; }
    function matchVariant() {
      var ok = function (v) { var nativeOptions = Array.prototype.every.call(root.querySelectorAll('[data-evani-option]'), function (select) { return v['option' + select.dataset.evaniOption] === select.value; }); return nativeOptions && (state.value === null || v.option1 === state.value) && (!sizePos || !state.size || v['option' + sizePos] === state.size); };
      return state.variants.filter(function (v) { return ok(v) && v.available; })[0] || state.variants.filter(ok)[0] || null;
    }
    root.addEventListener('change', function (event) { if (event.target.matches('[data-evani-option]')) { var variant = matchVariant(); if (variant) applyVariant(variant); else setAvailability(false); } });
    function showSizeTab(modal, n) {
      if (!modal) return;
      Array.prototype.forEach.call(modal.querySelectorAll('[data-tc-size-tab-btn]'), function (b) { var on = b.dataset.tcSizeTabBtn === String(n); b.classList.toggle('active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
      Array.prototype.forEach.call(modal.querySelectorAll('[data-tc-size-pane]'), function (p) { var on = p.dataset.tcSizePane === String(n); p.classList.toggle('active', on); p.classList.toggle('show', on); p.hidden = !on; });
    }
    function pickSize(btn) {
      var modal = btn.closest('[data-tc-size-modal]');
      Array.prototype.forEach.call(modal.querySelectorAll('[data-tc-size-pick]'), function (b) {
        var on = b === btn; b.classList.toggle('selected', on);
        var tr = b.closest('tr'); if (tr) { tr.classList.toggle('selected-row', on); var radio = tr.querySelector('[data-tc-size-radio]'); if (radio) radio.classList.toggle('is-selected', on); }
        var sr = b.querySelector('.selected-assistive-text'); if (sr) sr.textContent = on ? (root.dataset.tcSelectedLabel || 'selected') : '';
      });
      state.size = btn.dataset.tcSizePick;
      Array.prototype.forEach.call(root.querySelectorAll('[data-tc-size-value]'), function (el) { el.textContent = state.size; });
      if (mode !== 'reference') applyVariant(matchVariant());
      TC.overlay.close(modal);
    }

    function paintPrice(text) { Array.prototype.forEach.call(root.querySelectorAll('[data-tc-price]'), function (el) { el.textContent = text; }); }
    function setAvailability(available) {
      Array.prototype.forEach.call(root.querySelectorAll('.add-to-cart'), function (b) { b.disabled = !available; if (available) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true'); });
    }
    function showSet(set) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-tc-set]'), function (el) { el.hidden = el.dataset.tcSet !== set; });
      state.set = set; root.dataset.tcActiveSet = set;
      carousels.forEach(function (c) { c.update(); });
    }
    function selectSwatch(btn) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-tc-swatch]'), function (b) {
        var on = b === btn;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var v = b.querySelector('.swatch-value'); if (v) v.classList.toggle('selected', on);
        var sr = b.querySelector('.selected-assistive-text'); if (sr) sr.textContent = on ? (root.dataset.tcSelectedLabel || 'selected') : '';
      });
      state.value = btn.dataset.tcValue;
      if (mode === 'reference') {
        if (btn.dataset.tcChoiceSet) showSet(btn.dataset.tcChoiceSet);
        state.priceText = btn.dataset.tcChoicePrice || root.dataset.tcPriceText;
        paintPrice(state.priceText);
        return;
      }
      applyVariant(matchVariant());
    }
    function applyVariant(variant) {
      if (!variant) return;
      state.variant = variant;
      var idEl = root.querySelector('[data-tc-variant-id]'); if (idEl) idEl.value = variant.id;
      paintPrice(noDecimals(variant.priceText || TC.money(variant.price)));
      setAvailability(!!variant.available);
      if (root.dataset.tcReferenceImages !== 'true' && variant.featured_image && variant.featured_image.src) {
        var main = root.querySelector('.tc-main-image, [data-tc-main-image]');
        if (main) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = variant.featured_image.src; }
        var slide = variant.featured_media ? root.querySelector('[data-tc-media-id="' + variant.featured_media.id + '"]') : null;
        if (slide && slide.scrollIntoView) slide.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'smooth' });
      }
      if (window.history && history.replaceState) { try { var u = new URL(window.location.href); u.searchParams.set('variant', variant.id); history.replaceState({}, '', u.toString()); } catch (e) {} }
    }
    root.addEventListener('tc:variant:select', function (event) {
      var variant = event.detail;
      if (mode === 'reference' || !variant || !state.variants.some(function (v) { return v.id === variant.id; })) return;
      state.value = variant.option1;
      applyVariant(variant);
    });

    function referenceLine() {
      var setEl = root.querySelector('[data-tc-set="' + state.set + '"] img');
      return {
        referenceKey: root.dataset.tcReferenceKey,
        title: root.dataset.tcBrand,
        subtitle: root.dataset.tcName,
        image: setEl ? (setEl.currentSrc || setEl.src) : '',
        url: root.dataset.tcUrl || '#',
        quantity: 1,
        unitPrice: parseCents(state.priceText),
        options: (function () { var o = []; if (state.value) o.push({ name: root.dataset.tcOptionName || 'Option', value: state.value }); if (state.size && sizeBlock) o.push({ name: sizeBlock.dataset.tcSizeOption || 'Size', value: state.size }); return o; })()
      };
    }

    root.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-tc-swatch]');
      if (sw && root.contains(sw)) { e.preventDefault(); selectSwatch(sw); return; }
      var pick = e.target.closest('[data-tc-size-pick]');
      if (pick && root.contains(pick)) { e.preventDefault(); if (!pick.disabled) pickSize(pick); return; }
      var tabBtn = e.target.closest('[data-tc-size-tab-btn]');
      if (tabBtn && root.contains(tabBtn)) { e.preventDefault(); showSizeTab(tabBtn.closest('[data-tc-size-modal]'), tabBtn.dataset.tcSizeTabBtn); return; }
      var sizeOpener = e.target.closest('[data-tc-size-tab]');
      if (sizeOpener && root.contains(sizeOpener)) { showSizeTab(document.querySelector(sizeOpener.getAttribute('data-tc-open')), sizeOpener.dataset.tcSizeTab); }
      var add = e.target.closest('[data-tc-add],[data-tc-express-ref]');
      if (add && root.contains(add)) { e.preventDefault(); TC.cart.add(referenceLine()); TC.cart.setMode('reference'); TC.openMinicart(); return; }
      var tog = e.target.closest('[data-tc-express-toggle]');
      if (tog && root.contains(tog)) { e.preventDefault(); var ex = tog.closest('[data-tc-express]'); ex.classList.add('is-open'); tog.setAttribute('aria-expanded', 'true'); var first = ex.querySelector('.express-checkout-button__payment-buttons button, .express-checkout-button__payment-buttons [tabindex]'); if (first) first.focus(); return; }
      var cl = e.target.closest('[data-tc-express-close]');
      if (cl && root.contains(cl)) { e.preventDefault(); var ex2 = cl.closest('[data-tc-express]'); ex2.classList.remove('is-open'); var t2 = ex2.querySelector('[data-tc-express-toggle]'); if (t2) { t2.setAttribute('aria-expanded', 'false'); t2.focus(); } }
    });

    var form = root.querySelector('[data-tc-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btns = root.querySelectorAll('.add-to-cart');
        var err = root.querySelector('[data-tc-form-error]');
        Array.prototype.forEach.call(btns, function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
        if (err) { err.classList.add('d-none'); err.textContent = ''; }
        TC.cart.shopify.add(new FormData(form))
          .then(function () { TC.cart.setMode('shopify'); TC.openMinicart(); })
          .catch(function (j) { if (err) { err.textContent = (j && (j.description || j.message)) || 'Could not add this item to the cart.'; err.classList.remove('d-none'); } })
          .then(function () { Array.prototype.forEach.call(btns, function (b) { b.removeAttribute('aria-busy'); }); setAvailability(state.variant ? !!state.variant.available : true); });
      });
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-tc-gallery-mobile]'), function (el) {
      var c = TC.carousel(el); if (!c) return;
      carousels.push(c);
      var cur = el.querySelector('[data-tc-counter-current]'), tot = el.querySelector('[data-tc-counter-total]'), list = el.querySelector('.splide__list');
      function tick() {
        var slides = Array.prototype.filter.call(list.children, function (s) { return !s.hidden; });
        if (tot) tot.textContent = slides.length;
        var w = slides[0] ? slides[0].getBoundingClientRect().width : 0;
        var i = w ? Math.round(c.track.scrollLeft / w) : 0;
        if (cur) cur.textContent = Math.max(1, Math.min(slides.length, i + 1));
      }
      c.track.addEventListener('scroll', function () { window.requestAnimationFrame(tick); }, { passive: true });
      tick();
    });

    /* details column: --pdp-details-height feeds the captured sticky rule (top = min(header + banner, 100vh - details height)); measured from the column's content so the bottom edge pins to the viewport bottom */
    var details = root.querySelector('.product-container-position');
    if (details) {
      var syncDetails = function () {
        var kids = Array.prototype.filter.call(details.children, function (c) { return c.offsetParent !== null && getComputedStyle(c).position !== 'fixed'; });
        if (!kids.length) return;
        var first = kids[0].getBoundingClientRect(), last = kids[kids.length - 1].getBoundingClientRect();
        var pb = parseFloat(getComputedStyle(details).paddingBottom) || 0;
        details.style.setProperty('--pdp-details-height', Math.round(last.bottom - first.top + pb) + 'px');
      };
      if ('ResizeObserver' in window) { var ro = new ResizeObserver(function () { window.requestAnimationFrame(syncDetails); }); ro.observe(details); Array.prototype.forEach.call(details.children, function (c) { ro.observe(c); }); }
      /* the source sets --header-height-tiff / --slider-height once at load; the theme header re-measures them on scroll, so the column keeps its load-time values (top stays at header + banner) */
      var freezeHeader = function () {
        if (TC.syncHeaderVars) TC.syncHeaderVars();
        var rootStyle = getComputedStyle(document.documentElement);
        var h = rootStyle.getPropertyValue('--header-height-tiff').trim(), sl = rootStyle.getPropertyValue('--slider-height').trim();
        if (h) details.style.setProperty('--header-height-tiff', h);
        if (sl) details.style.setProperty('--slider-height', sl);
        syncDetails();
      };
      freezeHeader();
      window.addEventListener('load', freezeHeader);
      setTimeout(freezeHeader, 1300);
      var resizeTimer = null;
      window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(freezeHeader, 150); });
      window.addEventListener('resize', syncDetails);
      window.addEventListener('load', syncDetails);
      syncDetails();
    }
    /* editor: a selected appointment block shows both labels; a selected size / row block opens its aside */
    document.addEventListener('shopify:block:select', function (e) {
      if (!root.contains(e.target)) return;
      var st = e.target.getAttribute('data-tc-state');
      if (st === 'appointment') e.target.classList.add('is-editing');
      if (st === 'size') { var sm = e.target.querySelector('[data-tc-size-modal]'); if (sm) { showSizeTab(sm, 1); if (!TC.overlay.isOpen(sm)) TC.overlay.open(sm); } }
      if (st === 'row-link') { var rm = e.target.querySelector('.modal'); if (rm && !TC.overlay.isOpen(rm)) TC.overlay.open(rm); }
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      if (!root.contains(e.target)) return;
      e.target.classList.remove('is-editing');
      var om = e.target.querySelector('.modal'); if (om && TC.overlay.isOpen(om)) TC.overlay.close(om);
    });
    var sticky = root.querySelector('[data-tc-sticky]');
    var mainAdd = root.querySelector('[data-tc-main-add]');
    if (sticky) {
      if (sticky.dataset.tcStickyReveal === 'always' || !mainAdd || !('IntersectionObserver' in window)) sticky.classList.remove('hidden');
      else {
        var evalSticky = function () { var r = mainAdd.getBoundingClientRect(); var passed = r.bottom < 0; sticky.classList.toggle('hidden', !passed); };
        var io = new IntersectionObserver(function () { evalSticky(); }, { threshold: 0 });
        io.observe(mainAdd);
        window.addEventListener('scroll', function () { window.requestAnimationFrame(evalSticky); }, { passive: true });
        window.addEventListener('resize', evalSticky);
        evalSticky();
      }
      sectionEl.addEventListener('tc:editor:state', function (e) { if (e.detail === 'sticky') sticky.classList.remove('hidden'); });
    }
  });
})();
